module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-gorizia.svg?c70bc68678285c76d6f26e13ce52df54";